import { lazy } from 'react'


const DashboardAnalytics = lazy(() => import('../../views/dashboard/analytics'))
const DashboardEcommerce = lazy(() => import('../../views/dashboard/analytics'))

const DashboardRoutes = [
    {
        element: <DashboardAnalytics />,
        path: '/dashboard/analytics'
    },
    {
        element: <DashboardEcommerce />,
        path: '/dashboard/ecommerce'
    }
]

export default DashboardRoutes